import { render } from "./TrfChooserSimplesComValidacaoDeItemSelecionado.vue?vue&type=template&id=c38c7074&scoped=true"
import script from "./TrfChooserSimplesComValidacaoDeItemSelecionado.vue?vue&type=script&lang=js"
export * from "./TrfChooserSimplesComValidacaoDeItemSelecionado.vue?vue&type=script&lang=js"

import "./TrfChooserSimplesComValidacaoDeItemSelecionado.vue?vue&type=style&index=0&id=c38c7074&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38c7074"],['__file',"src/views/CadastroTarefas/components/WizardImportacaoDeTarefas/TrfChooserSimplesComValidacaoDeItemSelecionado.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c38c7074"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c38c7074', __exports__)) {
    console.log('reload')
    api.reload('c38c7074', __exports__)
  }
  
  module.hot.accept("./TrfChooserSimplesComValidacaoDeItemSelecionado.vue?vue&type=template&id=c38c7074&scoped=true", () => {
    console.log('re-render')
    api.rerender('c38c7074', render)
  })

}


export default __exports__